"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetadata = void 0;
const react_1 = __importStar(require("react"));
function useMetadata({ onChangeMetadata }) {
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const [metaState, setMetaState] = react_1.default.useState({
        errorFields: {},
        dirtyFields: {},
        touchedFields: {},
    });
    (0, react_1.useEffect)(() => {
        const meta = {
            isDirty: Object.values(metaState.dirtyFields).some(Boolean),
            isTouched: Object.values(metaState.touchedFields).some(Boolean),
            isValid: Object.values(metaState.errorFields).length === 0,
            isLoading,
        };
        onChangeMetadata?.({ ...metaState, meta });
    }, [onChangeMetadata, metaState, isLoading]);
    const updateErrors = newErrorFields => {
        setMetaState(prevMetaState => ({
            ...prevMetaState,
            errorFields: newErrorFields,
        }));
    };
    const updateDirtyFields = (name, status) => {
        setMetaState(prevMetaState => ({
            ...prevMetaState,
            dirtyFields: { ...prevMetaState.dirtyFields, [name]: status },
        }));
    };
    const updateTouchedFields = (name, status) => {
        setMetaState(prevMetaState => ({
            ...prevMetaState,
            touchedFields: { ...prevMetaState.touchedFields, [name]: status },
        }));
    };
    const { errorFields, dirtyFields, touchedFields } = metaState;
    return {
        updateErrors,
        updateDirtyFields,
        updateTouchedFields,
        onLoading: setIsLoading,
        metaState: {
            errorFields,
            dirtyFields,
            touchedFields,
            meta: {
                isDirty: Object.values(dirtyFields).some(Boolean),
                isTouched: Object.values(touchedFields).some(Boolean),
                isValid: Object.values(errorFields).length === 0,
                isLoading,
            },
        },
    };
}
exports.useMetadata = useMetadata;
//# sourceMappingURL=useMetadata.js.map